export const API_ENDPOINTS = {
    LOGIN: '/api/login',
    PRODUCTS: '/api/products',
    DOWNLOAD: '/api/download'
  };

export const API_BASE_URL = 'https://api.crm.tetraagroup.com/';